function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFileImageSmall = function SvgFileImageSmall(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: props.fill,
    fillRule: "evenodd",
    d: "M1.25 3.333c0-1.15.933-2.083 2.083-2.083h9.334c1.15 0 2.083.933 2.083 2.083v9.334c0 1.15-.933 2.083-2.083 2.083H3.333a2.083 2.083 0 0 1-2.083-2.083zm12 4.856V3.333a.583.583 0 0 0-.583-.583H3.333a.583.583 0 0 0-.583.583v9.334c0 .231.135.431.33.525l7.056-7.056a.75.75 0 0 1 1.061 0zM5.144 13.25h7.523a.583.583 0 0 0 .583-.583V10.31l-2.583-2.584zm.523-7.833a.25.25 0 1 0 0 .5.25.25 0 0 0 0-.5m-1.75.25a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0",
    clipRule: "evenodd"
  }));
};
export default SvgFileImageSmall;